import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { CustomInput } from "../../design/components/customComponents";

// Validation rules
const APP_NAME_MIN = 3;
const APP_NAME_MAX = 50;

const isAppNameValid = (value) => {
  const trimmed = value.trim();
  return trimmed.length >= APP_NAME_MIN && trimmed.length <= APP_NAME_MAX;
};

export default function AddOAuthAppModel({ onFormChange }) {
  const [appName, setAppName] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");

  // Compute error messages
  const appNameError =
    appName && !isAppNameValid(appName)
      ? `App name must be between ${APP_NAME_MIN} and ${APP_NAME_MAX} characters.`
      : "";
  const redirectUrlError =
    redirectUrl && redirectUrl?.trim() === ''
      ? "Enter a valid redirect URL"
      : "";

  // Notify parent about overall form validity
  useEffect(() => {
    const validName = isAppNameValid(appName);
    onFormChange(validName && !redirectUrlError, { appName, redirectUrl });
  }, [appName, redirectUrl, redirectUrlError]);

  return (
    <Box
      component="form"
      noValidate
      autoComplete="off"
      sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
    >
      <CustomInput
        label="App name"
        name="appName"
        type="text"
        value={{ value: appName, error: appNameError }}
        handleChange={(e) => setAppName(e.target.value)}
        handleFocus={() => {}}
        inputProps={{ maxLength: APP_NAME_MAX }}
      />

      <CustomInput
        label="Redirect URL"
        name="redirectUrl"
        type="url"
        value={{ value: redirectUrl, error: redirectUrlError}}
        handleChange={(e) => setRedirectUrl(e.target.value)}
        handleFocus={() => {}}
        placeholder="https://example.com/callback"
      />
    </Box>
  );
}
